import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	height: 69vh;
	padding: 1%;
	background-color: ${colors.grey1};
	overflow: clip scroll;
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	margin: 1% 0 0 0;
`;

export const KpiGridContainer = styled.div`
	display: flex;
`;

export const LoaderWrapper = styled.div`
	width: 100%;
	text-align: center;
	padding: 100px 0;
`;
